import styles from "./Eyebrow.module.css";

interface Props {
  children: React.ReactNode;
  /** Trailing hairline that runs to the end of the column. */
  rule?: boolean;
}

/**
 * §02 section eyebrow: mono, tracked 0.24em, cyan.
 *
 * NO SECTION NUMBER, and the `number` prop that carried one is GONE rather
 * than merely left unused at every call site. It rendered `03 — WHERE THE
 * VALUE IS`, and the numbers had drifted out of sequence: the fixture page
 * shipped "03" on BOTH "Where the value is" and the edge record, then jumped
 * to "05" for "Props by club". Each section hardcoded its own string, so
 * nothing kept them in order and nothing could notice they were wrong. A
 * number a reader can check and find wrong is worse than no number at all.
 *
 * Deleting the prop, rather than blanking the call sites, is what stops the
 * next section quietly reintroducing a stray one.
 */
export function Eyebrow({ children, rule = false }: Props) {
  return (
    <p className={styles.eyebrow}>
      {children}
      {rule && <span className={styles.rule} aria-hidden="true" />}
    </p>
  );
}
